import { ItemScheme } from '../../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../../Enums/MagicField.enum';

const formScheme: ItemScheme[] = [
	{
		type: MagicField.CHECKBOX,
		key: 'endocrinologyConsultation',
		title: 'diabetes.notificateOn.endocrinologyConsultation',
		settings: {
			hideRequired: true,
		},
	},
	{
		type: MagicField.CHECKBOX,
		key: 'cardiologyConsultation',
		title: 'diabetes.notificateOn.cardiologyConsultation',
		settings: {
			hideRequired: true,
		},
	},
	{
		type: MagicField.CHECKBOX,
		key: 'ophthalmologyConsultation',
		title: 'diabetes.notificateOn.ophthalmologyConsultation',
		settings: {
			hideRequired: true,
		},
	},
	{
		type: MagicField.CHECKBOX,
		key: 'dentalExamination',
		title: 'diabetes.notificateOn.dentalExamination',
		settings: {
			hideRequired: true,
		},
	},
	{
		type: MagicField.CHECKBOX,
		key: 'nutritionalAssessment',
		title: 'diabetes.notificateOn.nutritionalAssessment',
		settings: {
			hideRequired: true,
		},
	},
	{
		type: MagicField.CHECKBOX,
		key: 'psychologicalConsultation',
		title: 'diabetes.notificateOn.psychologicalConsultation',
		settings: {
			hideRequired: true,
		},
	},
	{
		type: MagicField.CHECKBOX,
		key: 'podiatricExamination',
		title: 'diabetes.notificateOn.podiatricExamination',
		settings: {
			hideRequired: true,
		},
	},
	{
		type: MagicField.CHECKBOX,
		key: 'gynecologicalExamined',
		title: 'diabetes.notificateOn.gynecologicalExamined',
		settings: {
			hideRequired: true,
		},
	},
	{
		type: MagicField.CHECKBOX,
		key: 'urologicalExamined',
		title: 'diabetes.notificateOn.urologicalExamined',
		settings: {
			hideRequired: true,
		},
	},
];

export default formScheme;
